var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1628 15.3792C18.8612 15.0774 18.503 14.838 18.1087 14.6747C17.7145 14.5114 17.292 14.4273 16.8652 14.4273C16.4385 14.4273 16.016 14.5114 15.6217 14.6747C15.2275 14.838 14.8693 15.0774 14.5676 15.3792L11.2853 18.6625C10.6761 19.2718 10.3339 20.0982 10.334 20.9599C10.3341 21.8216 10.6765 22.648 11.2858 23.2572C11.8952 23.8664 12.7216 24.2086 13.5833 24.2085C14.445 24.2085 15.2713 23.8661 15.8806 23.2567L16.1882 22.9654M15.8806 18.6625C16.1822 18.9643 16.5404 19.2037 16.9347 19.367C17.3289 19.5303 17.7514 19.6144 18.1782 19.6144C18.6049 19.6144 19.0274 19.5303 19.4217 19.367C19.8159 19.2037 20.1741 18.9643 20.4758 18.6625L23.7571 15.3792C24.3665 14.77 24.7088 13.9436 24.7089 13.0819C24.709 12.2203 24.3668 11.3938 23.7576 10.7845C23.1483 10.1751 22.322 9.83273 21.4603 9.83264C20.5986 9.83255 19.7722 10.1748 19.1628 10.784L18.1777 11.705",
    stroke: "#00ADEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.abb40fe22b731f8ae88ade5618082cdb.svg";
export { ForwardRef as ReactComponent };